import { RidangoReduxAction } from '@ridango/core';

import { RegisterActions } from './register.actions';

export const REGISTER_STATE_KEY = 'register';
export interface RegisterState {
    loaded: boolean;
    error: any;
    customer: any;
    registrationSteps: string[];
    registrationProgress: number;
    authAccessToken: string;
}

export const REGISTER_INITIAL_STATE: RegisterState = {
    loaded: false,
    error: null,
    customer: null,
    registrationProgress: 0,
    registrationSteps: ['ACCOUNT_CREATION_PROGRESS_YOUR_DETAILS', 'ACCOUNT_CREATION_PROGRESS_VERIFY_EMAIL'],
    authAccessToken: null,
};

export function registerReducer(
    lastState: RegisterState = REGISTER_INITIAL_STATE,
    action: RidangoReduxAction
): RegisterState {
    switch (action.type) {
        case RegisterActions.REGISTER_WITH_CREDENTIALS:
            return {
                ...lastState,
                error: null,
                loaded: false,
            };
        case RegisterActions.REGISTER_WITH_CREDENTIALS_SUCCESS:
            return {
                ...lastState,
                error: null,
                loaded: true,
            };
        case RegisterActions.REGISTER_WITH_CREDENTIALS_ERROR:
            return {
                ...lastState,
                error: action.payload,
                loaded: true,
            };
        case RegisterActions.REGISTER_SET_PROGRESS:
            return {
                ...lastState,
                registrationProgress: action.payload,
            };
        case RegisterActions.REGISTER_VERIFY_ACCOUNT:
            return {
                ...lastState,
                error: null,
                loaded: false,
            };
        case RegisterActions.REGISTER_VERIFY_ACCOUNT_SUCCESS:
            return {
                ...lastState,
                authAccessToken: action.payload,
                error: null,
                loaded: true,
            };
        case RegisterActions.REGISTER_VERIFY_ACCOUNT_ERROR:
            return {
                ...lastState,
                error: action.payload,
                loaded: true,
            };
    }
    // We don't care about any other actions right now.
    return lastState;
}
